import React, { useEffect, useState } from 'react';
import { Check, Trash2, Mail, Eye } from 'lucide-react';
import { contatoService } from '../../services/api';
import toast from 'react-hot-toast';

export default function AdminContatos() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState<any>(null);

  const load = () => { setLoading(true); contatoService.listar().then(r=>setItems(Array.isArray(r.data)?r.data:r.data.contatos||[])).catch(()=>toast.error('Erro')).finally(()=>setLoading(false)); };
  useEffect(load,[]);

  const marcarLido = async (id:string) => { try { await contatoService.marcarLido(id); toast.success('Marcado como lido'); load(); } catch { toast.error('Erro'); } };
  const deletar = async (id:string) => { if(!window.confirm('Excluir mensagem?')) return; try { await contatoService.deletar(id); setSelected(null); toast.success('Excluída!'); load(); } catch { toast.error('Erro.'); } };

  const naoLidos = items.filter(i=>!i.lido).length;

  return (
    <div>
      <div className="admin-page-header">
        <div style={{display:'flex',alignItems:'center',gap:12}}>
          <h1>Contatos</h1>
          {naoLidos>0&&<span className="badge badge-rosa">{naoLidos} não lido{naoLidos>1?'s':''}</span>}
        </div>
      </div>
      {loading ? <div className="loading-center"><div className="spinner"/></div> : (
        <div style={{overflowX:'auto'}}>
          <table className="admin-table">
            <thead><tr><th>Status</th><th>Nome</th><th>E-mail</th><th>Assunto</th><th>Data</th><th>Ações</th></tr></thead>
            <tbody>
              {items.length===0&&<tr><td colSpan={6} style={{textAlign:'center',padding:32,color:'var(--texto-leve)'}}>Nenhuma mensagem.</td></tr>}
              {items.map(item=>(
                <tr key={item._id} style={{background:item.lido?'':'rgba(232,133,61,0.04)'}}>
                  <td>{item.lido?<span style={{fontSize:'0.78rem',color:'var(--texto-leve)'}}>Lido</span>:<span style={{display:'inline-block',width:8,height:8,borderRadius:'50%',background:'var(--laranja)'}}/>}</td>
                  <td style={{fontWeight:item.lido?400:700,fontSize:'0.9rem'}}>{item.nome}</td>
                  <td style={{fontSize:'0.85rem'}}><a href={`mailto:${item.email}`}>{item.email}</a></td>
                  <td>{item.assunto&&<span className="badge badge-amarelo">{item.assunto}</span>}</td>
                  <td style={{fontSize:'0.82rem',color:'var(--texto-leve)'}}>{new Date(item.criadoEm).toLocaleDateString('pt-BR')}</td>
                  <td><div className="actions">
                    <button className="btn btn-outline btn-sm" title="Ver mensagem" onClick={()=>setSelected(item)}><Eye size={14}/></button>
                    {!item.lido&&<button className="btn btn-sm" style={{background:'#dcfce7',color:'#15803d',borderRadius:'var(--radius)'}} onClick={()=>marcarLido(item._id)}><Check size={14}/></button>}
                    <button className="btn btn-sm" style={{background:'#fee2e2',color:'#b91c1c',borderRadius:'var(--radius)'}} onClick={()=>deletar(item._id)}><Trash2 size={14}/></button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Detalhe */}
      {selected&&(
        <div className="admin-modal-overlay" onClick={()=>setSelected(null)}>
          <div className="admin-modal" style={{maxWidth:520}} onClick={e=>e.stopPropagation()}>
            <div className="admin-modal-header">
              <div style={{display:'flex',alignItems:'center',gap:10}}><Mail size={18} style={{color:'var(--laranja)'}}/><h3>Mensagem de {selected.nome}</h3></div>
              <button className="modal-close" onClick={()=>setSelected(null)}>✕</button>
            </div>
            <div className="admin-modal-body">
              <div style={{display:'flex',flexDirection:'column',gap:12}}>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  <div><p style={{fontSize:'0.72rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.08em',color:'var(--marrom-claro)',marginBottom:3}}>Nome</p><p style={{fontWeight:600,margin:0}}>{selected.nome}</p></div>
                  <div><p style={{fontSize:'0.72rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.08em',color:'var(--marrom-claro)',marginBottom:3}}>E-mail</p><a href={`mailto:${selected.email}`} style={{fontWeight:500}}>{selected.email}</a></div>
                </div>
                {selected.assunto&&<div><p style={{fontSize:'0.72rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.08em',color:'var(--marrom-claro)',marginBottom:3}}>Assunto</p><span className="badge badge-amarelo">{selected.assunto}</span></div>}
                <div><p style={{fontSize:'0.72rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.08em',color:'var(--marrom-claro)',marginBottom:8}}>Mensagem</p>
                  <div style={{background:'var(--creme)',borderRadius:'var(--radius)',padding:16,lineHeight:1.7,color:'var(--texto-leve)'}}>{selected.mensagem}</div>
                </div>
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="btn btn-outline" onClick={()=>setSelected(null)}>Fechar</button>
              <a href={`mailto:${selected.email}?subject=Re: ${selected.assunto||'Contato'}`} className="btn btn-primary"><Mail size={15}/> Responder</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
